import { ShieldCheck, Buildings as Build, Truck, Lightning } from "@phosphor-icons/react";

const ABOUT_IMG =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_diesel-deposit/artifacts/iqm8w620_Rot_about_Us.png";

export default function About() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-16">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
            About RODAIR
          </h1>
          <p className="mt-5 text-lg text-slate-600">
            RODAIR Investments & Services Limited (RC: 1117437) is a trusted bulk fuel supplier serving
            corporate organisations, financial institutions, manufacturers and religious bodies across Nigeria.
          </p>
          <p className="mt-4 text-slate-600">
            We combine dependable supply with a transparent, professional ordering process. Our platform gives
            procurement teams clear quotations, secure invoices and a straightforward payment-first workflow —
            so deliveries move smoothly and finances stay clear on both sides.
          </p>
          <p className="mt-4 rounded-lg bg-[#0A4F35]/5 border border-[#0A4F35]/15 p-4 text-slate-700">
            <span className="font-display font-semibold text-[#0A4F35]">Fast turnaround is our competitive edge.</span> Once
            payment is confirmed, we schedule and dispatch quickly — getting fuel to your site faster than the
            typical supplier, so your operations never wait.
          </p>
          <div className="mt-8 grid sm:grid-cols-2 gap-5">
            {[
              { icon: Lightning, t: "Fast turnaround", d: "Rapid scheduling & dispatch once payment clears." },
              { icon: Truck, t: "Reliable supply", d: "Bulk diesel & petrol, delivered to site." },
              { icon: Build, t: "Corporate-grade", d: "Built for banks, factories & institutions." },
              { icon: ShieldCheck, t: "Transparent", d: "Clear pricing and secure documentation." },
            ].map((f) => (
              <div key={f.t} className="flex items-start gap-3">
                <f.icon size={26} className="text-[#0A4F35] shrink-0" />
                <div>
                  <h3 className="font-display font-semibold text-slate-900">{f.t}</h3>
                  <p className="text-sm text-slate-500">{f.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="overflow-hidden rounded-lg border border-[#E5E7EB] bg-white">
          <img src={ABOUT_IMG} alt="About RODAIR Investments & Services Limited" className="w-full h-auto object-contain" />
        </div>
      </div>
    </div>
  );
}
